import { Component } from '@angular/core';
import { AppService } from '../services/app.service';
import { ActivatedRoute } from '@angular/router';
import { AuthCodeFormComponentUser } from '../utils/auth-code-form-user/auth-code-form-user.component';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-activate-driver',
    imports: [AuthCodeFormComponentUser, ButtonModule],
    templateUrl: './activate-driver.component.html',
    styleUrl: './activate-driver.component.scss'
})
export class ActivateDriverComponent {
token: string = '';
  client!: number;
  enProceso = false;
  showSuccess = false;
  showResponse = false;
  showOtp = false;
  data:string=''; 
  phoneNumber: string = '';

  constructor(private services: AppService, private route: ActivatedRoute,) {
    this.route.queryParamMap.subscribe((params) => {
      this.token = params.get('token') || '';
      this.data=params.get('data')||'';
      
    });
  }

  ngAfterViewInit(): void {


  }

  sendRequestActivate() {
    this.enProceso = true;
    var dcrypted= atob(this.data);
    var arrayInfo = dcrypted.trim().split('&');
    
    this.phoneNumber = arrayInfo[1].replaceAll("phone=","");
    this.client = parseInt(arrayInfo[2].replaceAll("client=",""));


    this.services.activateAccount(this.client, this.token, false,"", this.data,3).subscribe({
      next: (data: any) => {       
        this.enProceso = false;
        if (data.isSuccess) {
         
          if (data.message.includes('Mensaje enviado')) {
            this.showOtp = true;
          } else {
            this.showSuccess = true;
            this.showResponse = true;
            this.showOtp = false;
          }


        }
      },
      error: (error: any) => {
        this.showResponse = true;
        this.enProceso = false;
        this.showSuccess = false;

      }
    })
  }

  closeForm(resp: any) {
    this.showOtp = false;
    this.showResponse = true;
    this.showSuccess = resp==undefined?false:resp.success;    
  }

}
